import * as types from './types';

const updateNotifications = (data) => ({
   type: types.UPDATE_NOTIFICATIONS_DATA,
   payload: { data },
});
const markAllAsSeenNotificationsCompleted = () => ({
   type: types.MAKE_ALL_AS_SEEN_NOTIFICATIONS,
});

const markAllAsReadNotificationsCompleted = (id, bool = true) => ({
   type: types.MAKE_ALL_AS_READ_NOTIFICATIONS,
   payload: { id, bool },
});

const fetchNotificationsRequest = () => ({
   type: types.FETCH_NOTIFICATIONS_REQUEST,
});
const fetchNotificationsCompleted = (data) => ({
   type: types.FETCH_NOTIFICATIONS_COMPLETED,
   payload: data,
});
const fetchNotificationsFailed = (error) => ({
   type: types.FETCH_NOTIFICATIONS_FAILED,
   payload: error,
});

const fetchNewNotificationsRequest = () => ({
   type: types.FETCH_NEW_NOTIFICATIONS_REQUEST,
});
const fetchNewNotificationsCompleted = (data) => ({
   type: types.FETCH_NEW_NOTIFICATIONS_COMPLETED,
   payload: data,
});
const fetchNewNotificationsFailed = (error) => ({
   type: types.FETCH_NEW_NOTIFICATIONS_FAILED,
   payload: error,
});

const fetchNotificationsByFilterRequest = () => ({
   type: types.FETCH_NOTIFICATIONS_BY_FILTER_REQUEST,
});
const fetchNotificationsByFilterCompleted = (data) => ({
   type: types.FETCH_NOTIFICATIONS_BY_FILTER_COMPLETED,
   payload: data,
});
const fetchNotificationsByFilterFailed = (error) => ({
   type: types.FETCH_NOTIFICATIONS_BY_FILTER_FAILED,
   payload: error,
});

const setNotificationsPanelAction = (data) => ({
   type: types.SET_NOTIFICATIONS_PANEL,
   payload: data,
});

const setUnreadCountAction = (unreadCount) => ({
   type: types.SET_UNREAD_COUNT,
   payload: unreadCount,
});

const setUnseenCountAction = (unseenCount) => ({
   type: types.SET_UNSEEN_COUNT,
   payload: unseenCount,
});

export {
   updateNotifications,
   setNotificationsPanelAction,
   setUnreadCountAction,
   setUnseenCountAction,

   markAllAsSeenNotificationsCompleted,
   markAllAsReadNotificationsCompleted,

   fetchNotificationsRequest,
   fetchNotificationsCompleted,
   fetchNotificationsFailed,

   fetchNewNotificationsRequest,
   fetchNewNotificationsCompleted,
   fetchNewNotificationsFailed,

   fetchNotificationsByFilterRequest,
   fetchNotificationsByFilterCompleted,
   fetchNotificationsByFilterFailed,
};
